/**
 * The various files types that can be filtered
 */

export default Object.freeze({
    DOCUMENT: "document",
    AUDIO: "audio",
    VIDEO: "video",
    IMAGE: "image",
    OTHER: "other",
});
